export class StepAlias {
  public SCREENING = 'Triagem';
  public CONFIGURATION = 'Configuração';
  public DISPATCH = 'Expedição';
  public SCHEDULING = 'Planejamento';
  public MONITORING = 'Monitoramento';
  public VALIDATION = 'Validação';
  public FINISHED = 'Finalizado';
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/step-alias.ts